import React, { useState, useEffect } from 'react';
import FsLightbox from "fslightbox-react";

export default function ProductDetailImageGallery2(showImageUrls) {
    const [toggler, setToggler] = useState(false);
    const [productIndex, setProductIndex] = useState(1);
    const [currentImageList, setCurrentImageList] = useState([]);

    useEffect(() => {
        let arr = [];
        arr = showImageUrls.showImageUrls;
        arr = arr.filter(element => {
            return element !== null;
        });
        setCurrentImageList(arr);


    }, [showImageUrls.showImageUrls]);


    return (
        <>
            <div>
                <ul className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
                    {
                        currentImageList == null ? "" :
                            currentImageList.map((object, index) => (
                                object == null || object == "" ?
                                <></>:
                                <li className="relative" key={index}>
                                    <div key={index} className="wrapper-images group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-indigo-500 overflow-hidden">
                                        <img src={object == null || object == "" ? "" : object} alt="" className="object-cover pointer-events-none group-hover:opacity-75" />
                                        <button type="button" className="absolute inset-0 focus:outline-none"
                                            onClick={() => {
                                                setProductIndex(index);
                                                setToggler(!toggler);
                                            }}>
                                        </button>
                                    </div>
                                </li>
                            ))
                    }
                </ul>
                
                {
                    currentImageList == null || currentImageList.length == 0
                    ? <></>
                    :<FsLightbox
                    toggler={toggler}
                    sources={currentImageList}
                    sourceIndex={productIndex}
                />
                }
            </div>

        </>
    );
}